<template>
  <div style="padding-bottom: 60px" v-if="body_show">
    <div class="meacur_top">
      <h2>{{data.headtitle}}</h2>
      <div class="meacur_tx clearfix">
        <img :src="data.headimgurl" />
        <div class="meacur_txr">
          <h3>{{data.nickname}}</h3>
          <h4>{{data.ctime}}</h4>
        </div>
      </div>
      <!-- <div class="av" v-if="data.past_days>=30" @click="reset">重新测试</div>
      <div class="av" v-else style="background-color:#ccc">{{30-data.past_days}} 天后可重测</div> -->
    </div>
    <div class="meacur_main" style="margin-top: -30px;">
      <!-- title -->
      <h1 class="first">第一部分  能力自评报告</h1>
      <div class="mea_tb">
        能力热力图
      </div>
      <div class="meacut_tvc">
        <h1>下图是你的能力热力图：</h1>
        <!-- <h2 v-for="(item,index) in data.self_better_report" :key="index">{{item.title}}</h2> -->
      </div>
      <div class="meacut_t1">
        <div class="cep59_top">
          <div class="cep_rv">
            <div :class="['cp11',data.self_result_map['组织引领'].sort == 2 ?'cp12':'',data.self_result_map['组织引领'].sort == 3 ?'cp13':'',data.self_result_map['组织引领'].sort == 4 ?'cp14':'',data.self_result_map['组织引领'].sort == 5 ?'cp15':'']">组织引领</div>
            <div class="cp2">
              <div :class="['cp21',data.self_result_map['业务推进'].sort == 2 ?'cp22':'',data.self_result_map['业务推进'].sort == 3 ?'cp23':'',data.self_result_map['业务推进'].sort == 4 ?'cp24':'',data.self_result_map['业务推进'].sort == 5 ?'cp25':'']">业务推进</div>
              <div :class="['cp21s',data.self_result_map['团队管理'].sort == 2 ?'cp22s':'',data.self_result_map['团队管理'].sort == 3 ?'cp23s':'',data.self_result_map['团队管理'].sort == 4 ?'cp24s':'',data.self_result_map['团队管理'].sort == 5 ?'cp25s':'']">团队管理</div>
            </div>
            <div class="cp3">
              <div :class="['cp31s',data.self_result_map['学习思考'].sort == 2 ?'cp32s':'',data.self_result_map['学习思考'].sort == 3 ?'cp33s':'',data.self_result_map['学习思考'].sort == 4 ?'cp34s':'',data.self_result_map['学习思考'].sort == 5 ?'cp35s':'']">学习思考</div>
              <div :class="['cp31s',data.self_result_map['人际互动'].sort == 2 ?'cp32s':'',data.self_result_map['人际互动'].sort == 3 ?'cp33s':'',data.self_result_map['人际互动'].sort == 4 ?'cp34s':'',data.self_result_map['人际互动'].sort == 5 ?'cp35s':'']">人际互动</div>
            </div>
            <div class="cp4">自我驱动</div>
          </div>
        </div>
        <div class="cep_js clearfix">
          <ul>
            <li>
              <h2></h2>
              <h3>特优能力</h3>
            </li>
            <li>
              <h2></h2>
              <h3>优秀能力</h3>
            </li>
            <li>
              <h2></h2>
              <h3>良好能力</h3>
            </li>
            <li>
              <h2></h2>
              <h3>中等能力</h3>
            </li>
            <li>
              <h2></h2>
              <h3>劣势能力</h3>
            </li>
            <li>
              <h2></h2>
              <h3>加成能力</h3>
            </li>
          </ul>
        </div>
        <div class="meashow" style="margin-top:30px;">什么是能力热力图?</div>
        <div class="mea_h2" style="margin-bottom: 10px;">在结构方面，能力热力图可以划分为三层，从下至上分别为执行层、管理层、领导层。除自我驱动板块以外共5个板块，最上面为组织管理的能力，下面4项能力中，左侧两项是“对事”的能力板块，右侧是“对人”的能力；根据能力的差异，有专家型和管理型两种典型发展路径。</div>
        <div class="mea_h2" style="margin-bottom: 10px;">在颜色方面，采用热力图概念，能力板块得分越靠前，该板块的颜色越“热”，表示该能力板块越强。5个能力板块的排序情况如图所示。</div>
        <div class="meashow" style="margin-top:30px;">各个能力板块的界定</div>
        <div class="mea_h2" style="margin-bottom: 10px;"><span @click="showPops('组织引领')">组织引领(点击查看板块内能力界定,下同)：</span>指站在组织战略层面，高瞻远瞩，引领组织发展的能力，包括：商业头脑、战略思维、决策能力。</div>
        <div class="mea_h2" style="margin-bottom: 10px;"><span @click="showPops('业务推进')">业务推进：</span>指根据任务目标，通过计划、组织、监督、执行等方式促进任务顺利实施和目标达成的能力，包括：协调能力、推进执行、计划组织。</div>
        <div class="mea_h2" style="margin-bottom: 10px;"><span @click="showPops('团队管理')">团队管理：</span>指通过对组织人力资源的排布，提高组织生产力和达成组织目标的能力，包括：识人用人、团队凝聚、发展他人。</div>
        <div class="mea_h2" style="margin-bottom: 10px;"><span @click="showPops('学习思考')">学习思考：</span>指个体脑力方面的能力，包括：问题解决、学习领悟、创新能力。</div>
        <div class="mea_h2" style="margin-bottom: 10px;"><span @click="showPops('人际互动')">人际互动：</span>指与人打交道的能力，包括：关系管理、团队合作、说服影响。</div>
        <!-- <div class="meacut_tvc">
          <h1>优势板块：</h1>
          <h2 v-for="(item,index) in data.self_better_block" :key="index">{{item.category}}</h2>
        </div> -->
      </div>
    </div>
    <div class="meacur_main">
      <div class="mea_tb">
        能力模式
      </div>
      <div class="meashow" style="margin-top:30px;">什么是能力模式?</div>
      <div class="mea_h2" style="margin-bottom: 10px;">能力热力图中的各能力版块有其特定的用途与价值，不同的优势板块组合，形成了职业能力模式。了解自己的能力模式，有助于你在工作中扬长避短，找到适合自己的发展路径，充分发挥优势，助力职业发展。</div>
      <div class="meacut_tvc">
        <h1>你的能力模式：</h1>
        <!-- <h2 v-for="(item,index) in data.self_better_report" :key="index">{{item.title}}</h2> -->
      </div>
      <div class="meacut_tvc" v-for="(item,index) in data.self_better_report" :key="index">
        <h1 style="color: #333">{{item.title}}</h1>
        <h2 v-html="item.text"></h2>
      </div>
    </div>
    <div class="meacur_main">
      <div class="mea_tb">
        自我驱动
      </div>
      <div class="mea_h2" style="margin-bottom: 10px;"><span @click="showPops('自我驱动')">自我驱动</span>指的是个体对自身目标、思想、心理和行为等进行管理，促进自我奋斗目标实现的能力。包括具体能力：压力管理、适应变化、成就动机。</div>
      <div class="mea_h2" style="margin-bottom: 10px;">自我驱动就像个体发展的“发动机”，动力越充足，越有助于个体好发挥优势，促进职业发展，因此可以视为“加成能力”。</div>
      <div class="mea_h2" style="margin-bottom: 10px;">您的自我驱动板块星级和3项能力得分结果如下：</div>
      <div class="meacut_tvc">
        <h1>加成能力星级 <img src="@a/star_2.png" alt="" v-for="(item,index) in data.star" :key="index"/><img src="@a/star_1.png" alt="" v-for="(item,index) in (4-data.star)" :key="index"/></h1>
      </div>
      <div v-for="(item,index) in data.driving_result" :key="index" :class="['meacut_circle',index == data.driving_result.length-1?'last':'']">
        <van-circle v-model="currentRate" size="90px" layer-color="#dcdceb" :rate="(item.avg_t)" :stroke-width="60" color="#50509C">
          <h3 solt="default" class="circle_h3">
              {{item.avg_t}}<br/>{{item.division}}
          </h3>
        </van-circle>
        <h2 v-for="(itm,idx) in item.star_desc" :key="idx">{{itm}}</h2>
      </div>
      <div class="clearfix"></div>
    </div>
    <div class="meacur_main">
      <div class="mea_tb">
        能力优劣势
      </div>
      <div class="division">
        <ul>
          <li class="clearfix">
            <div class="div_l">
              5大优势
            </div>
            <div class="div_r">
              <span v-for="(item,index) in data.self_better_division" :key="index">{{item.division}}<span v-show="index<data.self_better_division.length-1">、</span></span>
            </div>
          </li>
          <li class="clearfix">
            <div class="div_l">
              3大劣势
            </div>
            <div class="div_r">
              <span v-for="(item,index) in data.self_worse_division" :key="index">{{item.division}}<span v-show="index<data.self_worse_division.length-1">、</span></span>
            </div>
          </li>
        </ul>
      </div>
      <div class="meacut_t1" v-for="(item,index) in data.self_result" :key="index">
        <div class="meacur_dv clearfix">
          <h4>{{item.category}}</h4>
          <ul class="clearfix">
            <li v-for="(itm,idx) in item.list" :key="idx" class="clearfix">
              <div :class="['dv_left',idx==0?'dv_left1':'']">
                {{itm.division}}
              </div>
              <div :class="['dv_right',idx==0?'dv_right1':'',idx==item.list.length-1?'dv_right2':'']">
                <h2 :style="{width:itm.avg_t + '%'}"></h2>
                <dl :class="['clearfix',idx==0?'dl1':'']">
                  <dt></dt>
                  <dt></dt>
                  <dt></dt>
                  <dt></dt>
                  <!-- <dt></dt> -->
                </dl>
              </div>
            </li>
          </ul>
          <div class="dv_bottom clearfix">
            <ul>
              <li>0</li>
              <li>25</li>
              <li>50</li>
              <li>75</li>
              <li class="b2">100</li>
            </ul>
          </div>
        </div>
      </div>
      <!-- <div class="mea_fot">
        <div class="mea_fov">
          注：
          <br/> 以上是你自评的结果，如果你在某项能力上的得分小于1分，得分参照意义有待商榷
        </div>
      </div> -->
    </div>
    <!-- 能力九宫格 -->
    <div class="meacur_main">
      <div class="mea_tb" style="margin-bottom: 40px;">
        能力九宫格
      </div>
      <div class="career-development Sudoku">
        <div class="mea_h2">在职业生涯发展中，个人要确定发展自己的哪些能力，除了要明确自身优劣势之外，更要清楚什么能力对自己的职业生涯发展是重要的（迫切且必要的),重要的能力得到优先关注和发展，才有利于职业的快速提升。</div>
        <div class="mea_h2 bold">依据你的能力水平和重要性评估结果，将能力分到9个区。其中，4、6、7、8、9五个区是需要重点关注的，详解见下面。</div>
        <img src="@a/sudoku1.png" alt="">
        <!-- child -->
        <div class="Sudoku-item">
          <h4>能力水平</h4>
          <p>依据自评结果，按排序将能力分为（相对你各项能力而言的）高、中、低三个水平。</p>
        </div>
        <div class="Sudoku-item">
          <h4>重要性</h4>
          <p>依据你对未来发展该能力的迫切必要程度综合判断，划分为高、中、低三个水平。</p>
        </div>
        <div class="Sudoku-item bt">
          <h4>落点可调整</h4>
          <p>能力在各个区的落点可以依据实际情况校准，但建议在相邻格子间移动。总体而言，越靠右侧的能力，重要性越高，提升的必要性越大。我们建议你重点关注对你最重要的能力。</p>
        </div>
        <!-- 重点关注区域 -->
        <div class="focus-on">
          <h2>重点关注区域</h2>
          <p>以下是你需要重点关注的区域，下表列出了这些区域的描述和能力发展建议，以及你落在这五个区域的能力。你可以利用这些信息，思考这些区域可能对你产生的影响，并制定策略达成你的目标。</p>
        </div>
        <!-- list -->
        <div v-for="(areasItem,index) in focus_areas" :key="index" class="focus-on-box">
          <div class="header">
            <h3>{{areasItem.name}} - {{areasItem.feature}}</h3>
            <button :style="{backgroundColor:areasItem.color}">{{areasItem.area}}</button>
          </div>
          <!-- 价值观 -->
          <div class="label-box">
            <div class="label-box-left">包括价值观：</div>
            <div v-if="areasItem.values && areasItem.values.length>0" class="label-box-right">
              <div v-for="(valuesItem,valuesIndex) in areasItem.values" :key="valuesIndex" class="label">{{valuesItem}}</div>
            </div>
            <div v-else class="label-box-right">
              <div class="label">无</div>
            </div>
          </div>
          <!-- content -->
          <div class="focus-on-content">
            <ul>
              <li v-for="(descItem,descIndex) in areasItem.desc" :key="descIndex">{{descItem}}</li>
            </ul>
          </div>
        </div>
        <p class="small">*其他四个区的特点与包括的能力，详见PDF版《能力报告》。</p>
      </div>
    </div>
    <div v-if="data.ta_count>=data.ta_need_count">
      <div class="meacur_main">
        <h1 class="first">第二部分 自评他评对比报告</h1>
        <div class="mea_h2" style="margin-bottom: 30px;">“以人为镜，可以知得失”。
          <br/>目前已有（{{data.ta_count}}）人对你的能力进行了评价，他评结果与自评结果的对比如下：</div>
        <div class="mea_tb" style="margin-bottom: 40px;">
          模式对比
        </div>
        <div class="meacut_tvc clearfix">
          <div class="mea_h2" style="margin-bottom: 20px;">通过自评与他评的能力模式对比,能够更好的了解自己的优势能力板块,从而有助于你选择更加适合自己的发展路径。</div>
          <div class="cep59_top_s">
            <div class="cep59_top cep59_top_small">
              <div class="cep_rv">
                <div :class="['cp11',data.self_result_map['组织引领'].sort == 2 ?'cp12':'',data.self_result_map['组织引领'].sort == 3 ?'cp13':'',data.self_result_map['组织引领'].sort == 4 ?'cp14':'',data.self_result_map['组织引领'].sort == 5 ?'cp15':'']">组织引领</div>
                <div class="cp2">
                  <div :class="['cp21',data.self_result_map['业务推进'].sort == 2 ?'cp22':'',data.self_result_map['业务推进'].sort == 3 ?'cp23':'',data.self_result_map['业务推进'].sort == 4 ?'cp24':'',data.self_result_map['业务推进'].sort == 5 ?'cp25':'']">业务推进</div>
                  <div :class="['cp21s',data.self_result_map['团队管理'].sort == 2 ?'cp22s':'',data.self_result_map['团队管理'].sort == 3 ?'cp23s':'',data.self_result_map['团队管理'].sort == 4 ?'cp24s':'',data.self_result_map['团队管理'].sort == 5 ?'cp25s':'']">团队管理</div>
                </div>
                <div class="cp3">
                  <div :class="['cp31s',data.self_result_map['学习思考'].sort == 2 ?'cp32s':'',data.self_result_map['学习思考'].sort == 3 ?'cp33s':'',data.self_result_map['学习思考'].sort == 4 ?'cp34s':'',data.self_result_map['学习思考'].sort == 5 ?'cp35s':'']">学习思考</div>
                  <div :class="['cp31s',data.self_result_map['人际互动'].sort == 2 ?'cp32s':'',data.self_result_map['人际互动'].sort == 3 ?'cp33s':'',data.self_result_map['人际互动'].sort == 4 ?'cp34s':'',data.self_result_map['人际互动'].sort == 5 ?'cp35s':'']">人际互动</div>
                </div>
                <div class="cp4">自我驱动</div>
              </div>
            </div>
            <h1>自评能力模式</h1>
          </div>
          <div class="cep59_top_s cep59_top_ss">
            <div class="cep59_top cep59_top_small">
              <div class="cep_rv">
                <div :class="['cp11',data.ta_result_map['组织引领'].sort == 2 ?'cp12':'',data.ta_result_map['组织引领'].sort == 3 ?'cp13':'',data.ta_result_map['组织引领'].sort == 4 ?'cp14':'',data.ta_result_map['组织引领'].sort == 5 ?'cp15':'']">组织引领</div>
                <div class="cp2">
                  <div :class="['cp21',data.ta_result_map['业务推进'].sort == 2 ?'cp22':'',data.ta_result_map['业务推进'].sort == 3 ?'cp23':'',data.ta_result_map['业务推进'].sort == 4 ?'cp24':'',data.ta_result_map['业务推进'].sort == 5 ?'cp25':'']">业务推进</div>
                  <div :class="['cp21s',data.ta_result_map['团队管理'].sort == 2 ?'cp22s':'',data.ta_result_map['团队管理'].sort == 3 ?'cp23s':'',data.ta_result_map['团队管理'].sort == 4 ?'cp24s':'',data.ta_result_map['团队管理'].sort == 5 ?'cp25s':'']">团队管理</div>
                </div>
                <div class="cp3">
                  <div :class="['cp31s',data.ta_result_map['学习思考'].sort == 2 ?'cp32s':'',data.ta_result_map['学习思考'].sort == 3 ?'cp33s':'',data.ta_result_map['学习思考'].sort == 4 ?'cp34s':'',data.ta_result_map['学习思考'].sort == 5 ?'cp35s':'']">学习思考</div>
                  <div :class="['cp31s',data.ta_result_map['人际互动'].sort == 2 ?'cp32s':'',data.ta_result_map['人际互动'].sort == 3 ?'cp33s':'',data.ta_result_map['人际互动'].sort == 4 ?'cp34s':'',data.ta_result_map['人际互动'].sort == 5 ?'cp35s':'']">人际互动</div>
                </div>
                <div class="cp4">自我驱动</div>
              </div>
            </div>
            <h1>他评能力模式</h1>
          </div>
        </div>
        <div class="meacut_tvc">
          <div class="cep_js clearfix">
            <ul>
              <li>
                <h2></h2>
                <h3>特优能力</h3>
              </li>
              <li>
                <h2></h2>
                <h3>优秀能力</h3>
              </li>
              <li>
                <h2></h2>
                <h3>良好能力</h3>
              </li>
              <li>
                <h2></h2>
                <h3>中等能力</h3>
              </li>
              <li>
                <h2></h2>
                <h3>劣势能力</h3>
              </li>
              <li>
                <h2></h2>
                <h3>加成能力</h3>
              </li>
            </ul>
          </div>
        </div>
        <div class="mea_fot">
          <div class="mea_fov">
            * “自评他评能力模式对比”的详细内容，请查看PDF版的详细报告。
          </div>
        </div>
        <!-- <div class="meacut_tvc">
        <h1>自评与他评能力排序：</h1>
        <div></div>

        <table class="tvc_table tvc_tables tvc_tabless">
          <tr>
            <td>他评排序</td>
            <td>能力项</td>
          </tr>
          <tr v-for="item in data.self_analyse_result_ta">
            <td>{{item.ta_sort}}</td>
            <td>{{item.division}}</td>
          </tr>
        </table>
      </div> -->
      </div>
      <div class="meacur_main">
        <div class="mea_tb">
          能力排序对比
        </div>
        <div class="mea_h2" style="margin-bottom: 10px;">对比自评和他评能力排序能够让你更好的了解自己眼中与他人眼中你的优劣势有什么样的不同。</div>
        <div class="mea_h2" style="margin-bottom: 10px;">下表列出了各项能力在自评和他评中的排序情况及排序差值（他评排序-自评排序）详情，差值为正值表示你对自己的评价更高；负值表示他人对你的评价更高，差值绝对值越大表示差异越大。</div>
        <table class="tvc_table tvc_tables">
          <tr>
            <td>能力项</td>
            <td>自评排序</td>
            <td>他评排序</td>
            <td>他评-自评</td>
          </tr>
          <tr v-for="(item,analyseIndex) in data.self_analyse_result" :key="analyseIndex">
            <td>{{item.division}}</td>
            <td :class="[item.sort<=5?'tr_red':'',item.sort>=16?'td_green':'']">{{item.sort}}</td>
            <td :class="[item.ta_sort<=5?'tr_red':'',item.ta_sort>=16?'td_green':'']">{{item.ta_sort}}</td>
            <td>{{item.ta_sort-item.sort}}</td>
          </tr>
        </table>
        <!-- <div class="mea_fot">
          <div class="mea_fov">
            注：
            <br/> 标红的是自评和他评的五大优势，标绿的是自评和他评的三大劣势。
          </div>
        </div> -->
      </div>
      <div class="meacur_main">
        <div class="mea_tb">
          评分差异
        </div>
        <!--  <div class="meacut_tvc">
          <div class="meacut_tvc">
            <h1>您对自己评价更高的能力：</h1>
            <h2 v-for="(item,index) in data.self_high_value" :key="index">{{item.division}}</h2>
          </div>
          <div class="meacut_tvc">
            <h1>别人对你评价更高的能力：</h1>
            <h2 v-for="(item,index) in data.ta_high_value" :key="index">{{item.division}}</h2>
          </div>
        </div> -->
        <div class="public-cart rgb-cart-box">
          <div @click="cartState2 = !cartState2" :class="[cartState2 ? 'tr' : '' ,'scroll-ico mt34 text-center']">
            <img src="@a/down-scroll.png" alt="" />
          </div>
          <p v-show="!cartState2" class="text-yellow mt34 text-center">点击查看得分差异详情</p>
          <p v-show="cartState2" class="text-yellow mt34 text-center">点击收起得分差异详情</p>
        </div>
        <div class="meacut_tvc" v-if="cartState2">
          <h1>自评与他评差值表</h1>
          <div class="mea_h2" style="margin-bottom: 10px;">下表列出了各项能力（自评得分-他评得分）的差值详情，差值为正值表示自己对自己的评价更高；负值表示他人对你的评价更高，差值绝对值越大表示差异越大。</div>
          <table class="tvc_table tvc_tables">
            <tr>
              <td>能力项</td>
              <td>自评</td>
              <td>他评</td>
              <td>自评-他评</td>
            </tr>
            <tr v-for="item in data.ta_analyse_result" :class="[item.diff>0.8?'tr_red':'',item.diff<-0.8?'tr_green':'']">
              <td>{{item.division}}</td>
              <td>{{item.avg_t}}</td>
              <td>{{item.ta_avg_t}}</td>
              <td>{{item.diff_t}}</td>
            </tr>
          </table>
          <!-- <div class="mea_fot">
            <div class="mea_fov">
              注：
              <br/> 标红的表示自评更高的能力，标绿的表示他评更高的能力。
            </div>
          </div> -->
        </div>
      </div>
      <div v-if="!$route.query.level_list_id" class="email-box">
        <div class="button" @click="fill_emails=true">详细报告发至邮箱</div>
      </div>
    </div>
    <!--职业发展进阶广告位  -->
    <div class="meacur_main">
      <div class="mea_tb" style="margin-bottom: 40px;">
        邀请他人评价
      </div>
      <div class="career-development">
        <div class="mea_h2" style="margin-bottom: 10px;">“以人为镜，可以知得失”，听取他人反馈有助于从多元视角描绘您的能力表现,识别自我认识盲区。把邀请卡转发给朋友或同事，邀请TA来为您匿名评价。</div>
        <div class="mea_h2" style="margin-bottom: 10px;font-weight:bold">为了提升结果的参考性，温馨提示如下：
          <br/> 1.请邀请熟悉你工作能力的人为你评价。建议包括：（前）同事、上级、下级或者外部客户
          <br/> 2.请提醒评价人客观评价，评价人越客观，结果对你的参照性越大
          <br/> 3.建议评价人数量：5-7人，可以上级、下级、同级或外部客户各2-3位
          <br/> 4.3人完成对你的评价后，才能形成PDF版报告
        </div>
        <div class="meacut_tvc">
          <h1>下面是你的专属邀请卡，长按下面图片，转发给评价人：</h1>
        </div>
        <img class="title-img" :src="data.ta_poster">
      </div>
    </div>
    <div class="email-box">
      <div class="bz">
        *本测评由新精英生涯（北京）教育科技有限公司版权所有，违者必究。
      </div>
    </div>
    <!-- 开启下一关卡 -->
    <div v-if="$route.query.level_list_id" class="levelbtn-group">
      <a @click="fill_emails=true" >将详细报告发送至邮箱</a>
      <a @click="list_link()" v-if="next.type == 1">开启“测评”</a>
      <a @click="list_link()" v-else-if="next.type == 2">开启下一课程</a>
      <a @click="list_link()" v-else-if="next.type == 3">开启“任务”</a>
      <a @click="list_link()" v-else-if="next.type == 5">去案例分析</a>
    </div>
    <!-- 发送邮箱 -->
    <van-popup v-model="fill_emails">
      <div class="confirm_box">
        <van-cell-group class="grouping">
          <van-field placeholder="请填写你的邮箱账号" v-model="mailbox" />
        </van-cell-group>
        <a class="cancel" href="javascript:;" @click="send_emails">确认</a>
      </div>
    </van-popup>
    <!-- 关注二维码 -->
    <van-popup class="radius" :close-on-click-overlay="false" v-model="isShow">
      <div class="pop pr text-center">
        <p>你的专属报告已生成</p>
        <p>长按识别关注公众号“立即查看”</p>
        <div class="text-center">
          <img class="qr-box" :src="qrcode" alt="" />
        </div>
      </div>
    </van-popup>
    <van-popup class="radius" :close-on-click-overlay="true" v-model="pop_show">
      <div class="pb-public">
        <div class="pop2">
          <p class="mt34" v-for="(item,index) in fl_group_list" :key="index"><span class="text-bold text-yellow">{{item.category}}</span>：{{item.division}}</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { acca65_report, acca65_reset, sendPdf} from "@/api/measurement";
import { shareCon } from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";
import { Dialog} from 'vant';
import { getLevel} from "@/api/course"
export default {
  data() {
      return {
        body_show: false,
        data: {},
        isShow: false,
        qrcode: '',
        fl_group: [],
        fl_group_list: [],
        self_result_sort: [],
        type_obj: {
          evaluation_id: "",
          evaluation_name: "",
          evaluation_id: "",
          nickname: ""
        },
        cartState2: false,
        pop_show: false,
        currentRate: 4,
        // 重点关注区域
        focus_areas: [],
        fill_emails: false,
        mailbox: '',
        // 关卡
        next:{}
      }
    },
    computed: {
      defaults() {
        return `我<br/>sdsd`
      }
    },
    methods: {
      /*
       *@param: 
       *@return: 
       *@Description: 开启下一个任务  1测评2音频3任务4小组讨论5案例
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-12-05 15:58:09
      */
      list_link() {
        let item = this.next;
        if (item.type == 1) {
          if(item.link.startsWith('http')){
            window.location.href = item.link+'?level_list_id=' + item.id;
          }else{
            this.$router.push({
              path:item.link,
              query:{
                level_list_id:item.id
              }
            })
          }
        } else if (item.type == 2) {
          this.$router.push('/course_content?cid=' + item.cid +'&level_list_id=' + item.id+ '&cpid=' + item.cpid + '&id=' + item.table_id)
        } else if (item.type == 3) {
          this.$router.push(item.link + '?cid=' + item.cid +'&level_list_id=' + item.id+ '&pid=' + item.cpid + '&id=' + item.table_id)
        } else if (item.type == 5) {
          this.$router.push('/case_analysis?id=' + item.id + '&level_list_id=' + item.id+'&cid=' + item.cid)
        }
      },
      send_emails() {
        if (this.$Validator.isEmail(this.mailbox)) {
          //调用加载中
          this.$emit('loadingHandle',true,"发送中");
          let q = this.$route.query;
           let ev_obj= {
            cid: 65,
            touser: this.mailbox
          };
          if(q.evaluation_id || q.evaluation_id==0){
            ev_obj['evaluation_id'] = q.evaluation_id;
          }
          sendPdf(ev_obj)
            .then((data) => {
              //关闭加载中
              this.$emit('loadingHandle',false);
              this.$toast(data.msg);
              setTimeout(() => {
                this.fill_emails = false
              }, 200)
            }).catch(() => {
              //关闭加载中
              this.$emit('loadingHandle',false);
              this.$toast('报告发送可能有几分钟的延迟，请耐心等待。');
              setTimeout(() => {
                this.fill_emails = false
              }, 200)
            });
        } else {
          this.$toast('邮箱填写不正确！');
        }

      },
      reset() {
        Dialog.confirm({
          title: '重新测评',
          message: '您确认要重测吗？'
        }).then(() => {
          acca65_reset()
            .then((data) => {
              this.$router.push("/acca65")
            })
        }).catch(() => {
          // on cancel
        });
      },
      showPops(title) {
        for (let arr in this.fl_group) {
          if (this.fl_group[arr].title == title) {
            this.fl_group_list = this.fl_group[arr].list;
          }
        }
        this.pop_show = true;
      },
      pullData() {
        //调用加载中
        this.$emit('loadingHandle',true,"拼命加载中...");
        let q = this.$route.query;
        // 获取关卡信息
        this.level_list_id = q.level_list_id?q.level_list_id:'';
        if(q.level_list_id){
          getLevel({
            level_list_id:this.level_list_id
          }).then((data)=>{
            this.next = data.next;
          });
        }
        let ev_obj= {};
        if(q.evaluation_id || q.evaluation_id==0){
          ev_obj['evaluation_id'] = q.evaluation_id;
        }
        acca65_report(ev_obj)
          .then((data) => {
            if (data.code != '10002') {
              document.title = data.headtitle;
              this.body_show = true;
              this.fl_group = [{
                title: "学习思考",
                list: [{
                  category: "学习领悟",
                  division: "对新知识保持渴求心态，能主动学习快速获取，并在实践中检验学习效果， 通过回顾和反思达到学习目标。"
                }, {
                  category: "问题解决",
                  division: "准确清晰地识别现存或预见的问题，收集、分析相关信息并提出有效的解决方案。"
                }, {
                  category: "创新能力",
                  division: "能够摆脱传统思维和常规经验的束缚，富有想象力和创意，实践中能够创造性地解决问题。"
                }]
              }, {
                title: "人际互动",
                list: [{
                  category: "团队合作",
                  division: "具有很强的团队精神和合作意识，时刻从团队利益出发，能够和团队成员融洽相处， 齐心协力解决问题， 为团队做出巨大贡献。 "
                }, {
                  category: "关系管理",
                  division: "能够与对自己有利的相关人士建立并保持良好关系，形成了完善的人际关系网。 "
                }, {
                  category: "说服影响",
                  division: "围绕目标，根据对象特点，运用数据、事实以及各种沟通技巧等手段来影响他人， 使对方接受自己的观点或使其产生自己期望的行为的一种能力。 "
                }]
              }, {
                title: "业务推进",
                list: [{
                  category: "协调能力",
                  division: "面临矛盾与冲突，能够运用恰当的策略进行沟通协调，以缓和或化解矛盾与冲突的能力。"
                }, {
                  category: "推进执行",
                  division: "持续推进任务的进行，并能够高效率的执行，在过程中能够灵活调整策略，保证任务目标的达成。"
                }, {
                  category: "计划组织",
                  division: "针对任务情况，能够快速制定行之有效的计划，并合理调配与运用资源，保证任务顺利进行。"
                }]
              }, {
                title: "团队管理",
                list: [{
                  category: "识人用人",
                  division: "能够根据员工的能力和个性特点，将其安排到合适的岗位上，在工作中使其扬长避短，实现价值。"
                }, {
                  category: "团队凝聚",
                  division: "合理运用各种激励资源，采取适当有效的方式和方法激发团队成员的工作热情与动力，以提高团队的整体战斗力。"
                }, {
                  category: "发展他人",
                  division: "工作中有培养他人的意识，通过多种方式指导、帮助其能力和素质的提高。"
                }]
              }, {
                title: "组织引领",
                list: [{
                  category: "商业敏感",
                  division: "一种看穿市场的洞察力，有商业头脑的人能准确判断市场发展潮流和趋势，并对大环境有深刻的见解。"
                }, {
                  category: "战略思维",
                  division: "从全局考虑，预见未来可能存在的挑战或机遇，主动进行谋划布局，系统性地形成对业务的认识和判断，并最终做出有创意的战略性决策过程。"
                }, {
                  category: "决策能力",
                  division: "依据对形势分析，做出恰当、合理、及时和实际的判断并采取行动"
                }]
              }, {
                title: "自我驱动",
                list: [{
                  category: "压力管理",
                  division: "指个人面对困境、批评、挑战或工作生活上的冲突，能够采取有效的方法，通过调整快速摆脱威胁性刺激所导致的生理或心理反应，如失眠、焦虑等，并从中学习、提升的能力。"
                }, {
                  category: "适应变化",
                  division: "通过自我改变以适应变化了的环境的能力。"
                }, {
                  category: "成就动机",
                  division: "指不满足于现状，对取得工作上的成功或自我的发展有强烈的渴求，勇于挑战难题，为追求高于一般标准的业绩而采取行动的能力。"
                }]
              }];
              this.data = data;
              this.qrcode = data.qrcode;
              this.focus_areas = data.focus_areas;
              let arry = data.self_result.concat();
              this.self_result_sort = arry.sort(function(a, b) {
                return b.avg - a.avg
              });
              if (this.data.need_subscribe && !this.data.subscribe) {
                this.isShow = true;
              };
              // 给wxconfig传对象
              this.type_obj.nickname = data.nickname;
              this.type_obj.evaluation_id = data.cid;
              this.type_obj.evaluation_name = data.headtitle;
              this.type_obj.evaluation_user_id = String(data.uid);
              this.type_obj.path = this.$route.path;

              shareCon("acca65", this, this.type_obj);
            } else {
              let redirect_query = deepCopy(this.$route.query);
              if(redirect_query.evaluation_id) {
                delete redirect_query.evaluation_id;
              }
              this.$router.push({
                path:'/acca65',
                query: redirect_query
              });
            }
            //关闭加载中
            this.$emit('loadingHandle',false);
          })
      }
    },
    created() {
      this.pullData();
    }
}
</script>
<style lang="scss">
@import "@s/remChange.scss";
.cep59_top {
  margin: 0 auto;
  margin-top: 80px;
  margin-bottom: 40px;
  text-align: center;
  display: flex;
  justify-content: center;
  .cep_rv {
    position: relative;
    .cp11 {
      background: url(../../../assets/cp59_11.png) no-repeat top center;
      background-size: cover;
      width: 211px;
      height: 186px;
      font-size: 34px;
      color: #fff;
      padding-top: 130px;
      margin: 0 auto;
    }
    .cp12 {
      background-image: url(../../../assets/cp59_12.png);
      background-size: cover;
    }
    .cp13 {
      background-image: url(../../../assets/cp59_13.png);
      background-size: cover;
    }
    .cp14 {
      background-image: url(../../../assets/cp59_14.png);
      background-size: cover;
    }
    .cp15 {
      background-image: url(../../../assets/cp59_15.png);
      background-size: cover;
    }
    .cp2 {
      display: flex;
      justify-content: center;
      margin-top: 10px;
      .cp21 {
        background: url(../../../assets/cp59_31.png) no-repeat top center;
        background-size: cover;
        width: 218px;
        height: 192px;
        font-size: 34px;
        color: #fff;
        padding-top: 135px;
        margin: 0 5px;
      }
      .cp22 {
        background-image: url(../../../assets/cp59_32.png);
        background-size: cover;
      }
      .cp23 {
        background-image: url(../../../assets/cp59_33.png);
        background-size: cover;
      }
      .cp24 {
        background-image: url(../../../assets/cp59_34.png);
        background-size: cover;
      }
      .cp25 {
        background-image: url(../../../assets/cp59_35.png);
        background-size: cover;
      }
      .cp21s {
        background: url(../../../assets/cp59_31s.png) no-repeat top center;
        background-size: cover;
        width: 218px;
        height: 192px;
        font-size: 34px;
        color: #fff;
        padding-top: 135px;
        margin: 0 5px;
      }
      .cp22s {
        background-image: url(../../../assets/cp59_32s.png);
        background-size: cover;
      }
      .cp23s {
        background-image: url(../../../assets/cp59_33s.png);
        background-size: cover;
      }
      .cp24s {
        background-image: url(../../../assets/cp59_34s.png);
        background-size: cover;
      }
      .cp25s {
        background-image: url(../../../assets/cp59_35s.png);
        background-size: cover;
      }
    }
    .cp3 {
      display: flex;
      justify-content: center;
      margin-top: 10px;
      .cp31s {
        background: url(../../../assets/cp59_21.png) no-repeat top center;
        background-size: cover;
        width: 322px;
        height: 196px;
        font-size: 34px;
        color: #fff;
        padding-top: 135px;
        margin: 0 16px;
      }
      .cp32s {
        background-image: url(../../../assets/cp59_22.png);
        background-size: cover;
      }
      .cp33s {
        background-image: url(../../../assets/cp59_23.png);
        background-size: cover;
      }
      .cp34s {
        background-image: url(../../../assets/cp59_24.png);
        background-size: cover;
      }
      .cp35s {
        background-image: url(../../../assets/cp59_25.png);
        background-size: cover;
      }
    }
    .cp4 {
      background-image: url(../../../assets/cp59_4.png);
      background-size: cover;
      position: absolute;
      bottom: 10px;
      left: 50%;
      margin-left: -106px;
      width: 212px;
      height: 186px;
      font-size: 34px;
      color: #fff;
      padding-top: 15px;
    }
  }
}

.cep59_top_s {
  width: 50%;
  float: left;
  margin-left: -20px;
  h1 {
    text-align: center;
    font-size: 28px;
  }
}

.cep59_top_s.cep59_top_ss {
  float: right;
  margin-right: -20px;
}

.cep59_top.cep59_top_small {
  margin-bottom: 20px;
  margin-top: 0;
  .cp11 {
    width: 102px;
    height: 89px;
    background-image: url(../../../assets/scp59_11.png) no-repeat top center;
    background-size: cover;
    padding-top: 62px;
    font-size: 16px;
  }
  .cp12 {
    background-image: url(../../../assets/scp59_12.png);
    background-size: cover;
  }
  .cp13 {
    background-image: url(../../../assets/scp59_13.png);
    background-size: cover;
  }
  .cp14 {
    background-image: url(../../../assets/scp59_14.png);
    background-size: cover;
  }
  .cp15 {
    background-image: url(../../../assets/scp59_15.png);
    background-size: cover;
  }
  .cp2 {
    .cp21 {
      background: url(../../../assets/scp59_31.png) no-repeat top center;
      background-size: cover;
      width: 103px;
      height: 92px;
      font-size: 16px;
      color: #fff;
      padding-top: 65px;
      margin: 0 5px;
    }
    .cp22 {
      background-image: url(../../../assets/scp59_32.png);
      background-size: cover;
    }
    .cp23 {
      background-image: url(../../../assets/scp59_33.png);
      background-size: cover;
    }
    .cp24 {
      background-image: url(../../../assets/scp59_34.png);
      background-size: cover;
    }
    .cp25 {
      background-image: url(../../../assets/scp59_35.png);
      background-size: cover;
    }
    .cp21s {
      background: url(../../../assets/scp59_31s.png) no-repeat top center;
      background-size: cover;
      width: 103px;
      height: 92px;
      font-size: 16px;
      color: #fff;
      padding-top: 65px;
      margin: 0 5px;
    }
    .cp22s {
      background-image: url(../../../assets/scp59_32s.png);
      background-size: cover;
    }
    .cp23s {
      background-image: url(../../../assets/scp59_33s.png);
      background-size: cover;
    }
    .cp24s {
      background-image: url(../../../assets/scp59_34s.png);
      background-size: cover;
    }
    .cp25s {
      background-image: url(../../../assets/scp59_35s.png);
      background-size: cover;
    }
  }
  .cp3 {
    .cp31s {
      background: url(../../../assets/cp59_21.png) no-repeat top center;
      background-size: cover;
      width: 154px;
      height: 94px;
      font-size: 16px;
      color: #fff;
      padding-top: 68px;
      margin: 0 14px;
    }
    .cp32s {
      background-image: url(../../../assets/cp59_22.png);
      background-size: cover;
    }
    .cp33s {
      background-image: url(../../../assets/cp59_23.png);
      background-size: cover;
    }
    .cp34s {
      background-image: url(../../../assets/cp59_24.png);
      background-size: cover;
    }
    .cp35s {
      background-image: url(../../../assets/cp59_25.png);
      background-size: cover;
    }
  }
  .cp4 {
    background-image: url(../../../assets/cp59_4.png);
    background-size: cover;
    position: absolute;
    bottom: 2px;
    left: 50%;
    margin-left: -51px;
    width: 102px;
    height: 90px;
    font-size: 16px;
    color: #fff;
    padding-top: 6px;
  }
}

.division {
  border: 2px solid #ccc;
  border-bottom: none;
  margin: 0 auto;
  margin-top: 80px;
  ul {
    li {
      background-color: #EFDFE1;
      position: relative;
      border-bottom: 2px solid #ccc;
      .div_l {
        position: absolute;
        font-size: 34px;
        color: #333;
        left: 32px;
        top: 50%;
        transform: translateY(-50%);
        font-weight: bold;
      }
      .div_r {
        border-left: 2px solid #ccc;
        width: 440px;
        padding: 32px;
        padding-right: 70px;
        line-height: 40px;
        color: #333;
        font-size: 26px;
        float: right;
        text-align: justify;
      }
    }
    li:last-child {
      border-bottom: none;
      background-color: #D7E4E3;
    }
  }
}

.tvc_table {
  margin: 0 auto;
  margin-top: 30px;
  font-size: 26px;
  color: #333;
  width: 100%;
  tr {
    // background-color: #D7E4E3;
    td {
      text-align: center;
      padding: 40px;
    }
    // .td_red {
    //   background-color: #e25065;
    // }
    // .td_green {
    //   background-color: #6edb8f;
    // }
  }
  tr:nth-child(odd) {
    // background-color: #EFDFE1;
  }
  tr:first-child {
    background-color: #f57f17;
    color: #fff;
    font-weight: bold;
  }
}

.tvc_tables {
  tr {
    td {
      text-align: center;
      padding: 20px;
    }
  }
  // .tr_red {
  //   background-color: #e25065;
  // }
  // .tr_green {
  //   background-color: #6edb8f;
  // }
}

.tvc_tabless {
  width: 50%;
  float: left;
}

.public-cart {
  .scroll-ico {
    transition: all .5s;
    transform: rotateZ(0deg);
    img {
      width: 58px;
      height: 58px;
    }
  }
  .tr {
    transform: rotateZ(180deg);
  }
}

.mt34 {
  margin-top: 34px;
}

.title-2 {
  color: #222;
  font-weight: bold;
}

.bold-yellow {
  color: #F57F17;
  text-decoration: underline;
}

.show-img {
  margin-top: 51px;
  img {
    max-width: 100%;
  }
}

.cep_js {
  margin: 0 10px;
  margin-top: 60px;
  ul li {
    float: left;
    text-align: center;
    width: 16.66%;
    h2 {
      width: 100%;
      height: 30px;
      background-color: #E28824;
    }
    h3 {
      margin-top: 10px;
      font-size: 20px;
      color: #333;
    }
  }
  ul li:nth-child(1) h2 {
    background-color: #D93F36;
    border-radius: 6px 0px 0px 6px;
  }
  ul li:nth-child(3) h2 {
    background-color: #0497D8;
  }
  ul li:nth-child(4) h2 {
    background-color: #41AD49;
  }
  ul li:nth-child(5) h2 {
    background-color: #BCD632;
  }
  ul li:nth-child(6) h2 {
    background-color: #452B5E;
    border-radius: 0px 6px 6px 0px;
  }
}

.radius {
  border-radius: 10px;
}

.pop {
  width: 8rem;
  padding-bottom: 80px;
  p:nth-child(1) {
    padding-top: 50px;
    font-size: 34px;
    line-height: 80px;
    font-weight: bold;
    color: #F57F17;
  }
  p:nth-child(2) {
    color: #333;
    font-size: 30px;
    line-height: 80px;
  }
  img {
    width: 80%;
  }
}

.men_detail {
  width: 100%;
  text-align: center;
  img {
    width: 100%;
  }
}

.men_foots {
  width: 100%;
  height: changeRem(1.96) + px;
  line-height: changeRem(1.96) + px;
  position: fixed;
  bottom: 0;
  left: 50%;
  margin-left: -375px;
  max-width: 750px;
  text-align: center;
  background: #EB5032;
  z-index: 2;
  color: #fff;
  font-size: changeRem(0.68) + px;
  a {
    display: block;
    width: 100%;
    height: 100%;
  }
}

.meacur_top {
  background: url(../../../assets/measue_bg.png) no-repeat top center;
  background-size: cover;
  width: 100%;
  height: changeRem(9.3) + px;
  padding: 0 changeRem(.6) + px;
  padding-top: changeRem(.65) + px;
  text-align: left;
  h2 {
    font-size: changeRem(1.08) + px;
    line-height: changeRem(1.6) + px;
    color: #fff;
    width: changeRem(8.8) + px;
    font-weight: bold;
  }
}

.meacur_tx {
  margin-top: changeRem(.6) + px;
  img {
    border-radius: 50%;
    width: changeRem(2) + px;
    height: changeRem(2) + px;
    float: left;
  }
}

.meacur_txr {
  float: left;
  margin-left: changeRem(.5) + px;
  h3 {
    color: #fff;
    font-size: changeRem(.64) + px;
    line-height: changeRem(1.1) + px;
  }
  h4 {
    color: #fff;
    font-size: changeRem(.52) + px;
    line-height: changeRem(.7) + px;
  }
}

.meacur_main {
  width: changeRem(13.8) + px;
  background: #fff;
  border-radius: changeRem(.16) + px;
  margin: 0 auto;
  margin-top: changeRem(.8) + px;
  padding: changeRem(1.2) + px changeRem(.6) + px;
  text-align: center;
}

// 第一部分标题
.first {
  display: flex;
  line-height: 70px;
  font-size: 42px;
  font-weight: bold;
  background-color: #ffffff;
  color: #333333;
  justify-content: center;
  margin: 0 auto;
  margin-bottom: 40px;
}

.email-box {
  padding: 0 30px;
  .bz {
    margin-top: 60px;
    font-size: 24px;
    color: #999;
    text-align: justify;
  }
  .button {
    width: 750px;
    line-height: 98px;
    text-align: center;
    color: #fff;
    background-color: #EB5032;
    font-size: 34px;
    margin-top: 60px;
    position: fixed;
    left: 50%;
    margin-left: -375px;
    bottom: 0;
  }
}

.mea_tb {
  background: url(../../../assets/ma_bg.png) no-repeat top center;
  background-size: cover;
  width: changeRem(11.72) + px;
  line-height: changeRem(1.2) + px;
  height: changeRem(1.2) + px;
  margin: 0 auto;
  text-align: center;
  color: #fff;
  font-size: changeRem(.72) + px;
  font-weight: bold;
}

.mea_h2 {
  line-height: changeRem(.8) + px;
  color: #666;
  font-size: changeRem(.52) + px;
  text-align: justify;
  margin: changeRem(.8) + px 0;
  span {
    color: #F57F17;
    text-decoration: underline;
    font-weight: bold;
  }
}

.meashow {
  font-size: 38px;
  color: #F57F17;
  font-weight: bold;
  margin-top: 20px;
  text-align: left;
}

.meacut_t1 {
  text-align: left;
  border-bottom: 2px dashed #ccc;
  padding-bottom: 20px;
  .meashow_table {}
  .meacut_zk {
    width: 100%;
    margin-top: changeRem(1) + px;
    h4 {
      font-size: changeRem(.48) + px;
      text-align: left;
      color: #333;
      line-height: changeRem(1) + px;
      width: 100%;
    }
    .zk {
      width: changeRem(11) + px;
      height: changeRem(11) + px;
      border-left: changeRem(.04) + px solid #EB5032;
      border-bottom: changeRem(.04) + px solid #EB5032;
      padding: changeRem(.44) + px;
      margin-left: changeRem(.68) + px;
      li {
        float: left;
        width: 50%;
        img {
          width: 100%;
          vertical-align: middle;
        }
      }
    }
    .rig {
      text-align: right;
    }
  }
  .mea_vb {
    margin-top: changeRem(.35) + px;
    color: #333;
    font-weight: bold;
    text-align: justify;
    font-size: changeRem(.52) + px;
    h1 {
      font-size: 32px;
      font-weight: bold;
    }
    h2 {
      font-size: 30px;
      color: #666;
    }
    span {
      color: #EB5032;
    }
  }
  .mea_fov {
    margin-top: changeRem(.3) + px;
  }
}

.mea_fot {
  margin-top: 20px;
  width: 100%;
  margin-bottom: 30px;
  text-align: justify;
  color: #666;
  line-height: 40px;
  font-size: 24px;
}

.meacur_dv {
  width: 100%;
  position: relative;
  margin-top: changeRem(.96) + px;
  h4 {
    color: #333;
    font-size: changeRem(.6) + px;
    position: absolute;
    left: 0;
    top: -10px;
    padding-bottom: changeRem(.2) + px;
    font-weight: bold;
  }
  .dv_top {
    position: absolute;
    right: 0;
    top: changeRem(.08) + px;
    font-size: changeRem(.4) + px;
    color: #333;
    line-height: 0;
    span {
      display: inline-block;
      width: changeRem(.56) + px;
      height: changeRem(.24) + px;
      background: rgba(238, 238, 238, 1);
      margin-right: changeRem(.2) + px;
      vertical-align: middle;
    }
  }
  .dv_top1 {
    right: changeRem(4.2) + px;
    span {
      background-color: #6DABF1;
    }
  }
  .dv_top2 {
    right: 40px;
    span {
      background-color: #EF735B;
    }
  }
  .dv_left {
    float: left;
    width: changeRem(2) + px;
    font-size: changeRem(.48) + px;
    text-align: right;
    padding-top: changeRem(.1) + px;
    height: changeRem(1.4) + px;
  }
  .dv_right {
    width: changeRem(9.6) + px;
    float: right;
    border-left: changeRem(.04) + px solid #ccc;
    position: relative;
    height: changeRem(1.4) + px;
    h2 {
      height: changeRem(.56) + px;
      background: #50509C;
      position: relative;
      z-index: 1;
    }
    h2.sum {
      background-color: #6DABF1;
    }
    h2.spe {
      background-color: #eee;
    }
    dl {
      position: absolute;
      z-index: 0;
      top: 0;
      left: 0;
      display: flex;
      width: 100%;
      dt {
        width: 20%;
        border-right: changeRem(.04) + px dashed #eee;
        height: changeRem(1.3) + px;
      }
      dt.m1_dt {
        border-right-color: #F57F17;
      }
    }
    dl.dl1 {
      top: changeRem(.6) + px;
      dt {
        height: changeRem(1) + px;
      }
    }
  }
  .dv_left1 {
    height: changeRem(2.3) + px;
    padding-top: changeRem(.92) + px;
  }
  .dv_right1 {
    height: changeRem(2.3) + px;
    padding-top: changeRem(.92) + px;
  }
  .dv_right2 {
    border-bottom: changeRem(.04) + px solid #ccc;
  }
  .dv_bottom {
    width: changeRem(9.6) + px;
    float: right;
    margin-top: changeRem(.2) + px;
    position: relative;
    ul{
      display: flex;
      li {
        flex: 1;
        color: #333;
        font-size: changeRem(.44) + px;
        text-align: left;
      }
    }
    li.b3 {
      position: absolute;
      right: changeRem(-0.3) + px;
      bottom: 0;
    }
    li.b4 {
      margin-left: changeRem(2.65) + px;
    }
    li.b5 {
      margin-left: changeRem(2.3) + px;
    }
  }
}

.mea_h2s {
  margin-bottom: 10px;
  span {
    color: #EB5032;
  }
}

.yos {
  width: 100%;
  margin-top: changeRem(0.8) + px;
  .yos_main {
    width: changeRem(3) + px;
    margin-right: changeRem(0.2) + px;
    text-align: center;
    float: left
  }
  .yos_mainlast {
    margin-right: 0
  }
}

.yos .yos_main h2 {
  line-height: changeRem(1) + px;
  font-size: changeRem(0.52) + px;
  color: #333;
  font-weight: bold
}

.yos .yos_main ul li {
  width: 100%;
  position: relative;
  height: changeRem(3) + px;
  background: #ccc;
  margin-top: changeRem(0.2) + px
}

.yos .yos_main ul li .yos_k {
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  left: 0;
  color: #fff;
  font-size: changeRem(0.52) + px;
  line-height: changeRem(1) + px
}

.yos .yos_main ul li.sun1 {
  background-color: #F39684
}

.yos .yos_main ul li.sun2 {
  background-color: #EF735B
}

.yos .yos_main ul li.sun3 {
  background-color: #EB5032
}

.jas_main {}

.jas_main h2 {
  color: #EB5032;
  font-size: changeRem(0.64) + px;
  text-align: left;
  line-height: changeRem(0.85) + px;
  padding-top: changeRem(0.8) + px;
  border-top: 2px solid #ccc
}

.jas_main ul.j_v li {
  padding-bottom: changeRem(0.8) + px;
  border-bottom: 2px solid #ccc
}

.jas_main ul.j_v li:last-child {
  padding-bottom: 0;
  border-bottom: none
}

.jas_main ul.j_v li img {
  float: left;
  width: changeRem(5.8) + px
}

.jas_main ul.j_v li .jas_r {
  width: changeRem(6.1) + px;
  float: right
}

.jas_main ul.j_v li .jas_r h3 {
  line-height: changeRem(0.8) + px;
  font-size: changeRem(0.64) + px;
  color: #333;
  text-align: left
}

.jas_main ul.j_v li .jas_r a {
  display: block;
  line-height: changeRem(1) + px;
  font-size: changeRem(0.64) + px;
  width: changeRem(3.76) + px;
  color: #fff;
  margin-top: changeRem(1.2) + px;
  border-radius: changeRem(0.5) + px;
  background: #EB5032
}

.jas_main ul.cep {
  margin-top: changeRem(0.88) + px
}

.jas_main ul.cep li {
  width: changeRem(1.6) + px;
  float: left;
  text-align: center
}

.jas_main ul.cep li img {
  width: changeRem(1.6) + px
}

.jas_main ul.cep li p {
  color: #999;
  font-size: changeRem(0.52) + px
}

.jas_main ul.cep li:nth-child(even) {
  width: changeRem(3.72) + px;
  padding-top: changeRem(0.8) + px
}

.jas_main ul.cep li:nth-child(even) h4 {
  width: 100%;
  height: changeRem(0.04) + px;
  background: #ccc
}

.jas_main ul.cep li:last-child {
  width: changeRem(2.1) + px;
  text-align: left
}

.jas_main ul.cep li.spe {
  width: changeRem(3.55) + px
}

.jas_main ul.cep li:last-child p {
  margin-left: changeRem(-0.2) + px
}

.jas_main ul.cep li.on p {
  color: #F57F17
}

.jas_main ul.cep li:nth-child(even).on h4 {
  background-color: #F57F17
}

.jas_v {
  width: 100%;
  margin-top: changeRem(0.8) + px
}

.jas_v h2 {
  font-size: changeRem(0.64) + px;
  color: #333;
  text-align: left
}

.jas_v ul {
  margin-top: changeRem(0.6) + px;
  width: auto;
  overflow-x: scroll;
  display: flex
}

.jas_v li {
  width: changeRem(1.2) + px;
  margin-right: 0;
  float: left;
  margin-right: changeRem(0.6) + px;
  text-align: center
}

.jas_v li img {
  width: changeRem(1.2) + px;
  height: changeRem(1.2) + px;
  border-radius: 50%
}

.jas_v li p {
  font-size: changeRem(0.4) + px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%
}

img.give_share {
  width: 100%;
  position: fixed;
  top: 0;
  left: 50%;
  z-index: 1000;
  height: 100%;
  max-width: 750px;
  margin-left: -375px;
}

// 广告位
.career-development {
  margin-top: 30px;
  padding: 0 30px;
  img.title-img {
    width: 100%;
    margin-top: 40px;
  }
  .career-small {
    background: #E99850;
    padding: 36px 20px 30px 20px;
    div.small-txt {
      background: url(../../../assets/advertising_bg.png) center no-repeat;
      width: 100%;
      height: 275px;
      background-size: contain;
      padding: 32px 22px 36px 22px;
      font-size: 32px;
      line-height: 44px;
      color: #333;
      text-indent: 3em;
    }
    .bg {
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
      background-color: #fff;
      padding: 34px 26px 38px;
      h2.title-h2 {
        text-align: center;
        margin-bottom: 26px;
        color: #E99850;
        font-size: 32px;
        letter-spacing: 1px;
      }
      h3.title-h3 {
        font-size: 28px;
        color: #666666;
        line-height: 42px;
        margin-bottom: 50px;
      }
      h4.title-h4 {
        font-size: 28px;
        color: #333333;
      }
      ul {
        list-style: disc;
        font-size: 28px;
        color: #333333;
        li {
          list-style: disc;
          list-style-position: inside;
        }
      }
      hr {
        margin: 34px auto 38px;
        border: 1px dashed #532C0B;
      }
      .advertising-link {
        position: relative;
        img {
          display: inline-block;
          vertical-align: top;
          width: 282px;
          height: 176px;
        }
        .right {
          display: inline-block;
          width: 286px;
          text-align: left;
          vertical-align: top;
          position: absolute;
          top: 0;
          right: 0;
          h2 {
            font-size: 32px;
            color: #333333;
            line-height: 39px;
            text-align: left;
            font-weight: bold;
          }
          button {
            border-radius: 25px;
            background-color: #EB5032;
            color: #fff;
            width: 188px;
            line-height: 50px;
            border: none;
            margin-top: 15px;
          }
        }
      }
    }
    .tbd {
      height: 30px;
      width: 100%;
      background-color: #fff;
    }
  }
  .career-small.on {
    padding-top: 0;
  }
  .hr {
    height: 4px;
    background: rgba(237, 167, 104, 1);
  }
}

.career-development.Sudoku {
  padding: 0;
  margin-top: 0;
  .mea_h2 {
    margin: 0;
  }
  .bold {
    font-weight: bold;
    margin: 28px auto 60px;
  }
  img {
    width: 610px;
    margin: 0 auto 60px;
  }
  .Sudoku-item {
    margin-bottom: 30px;
    text-align: left;
    h4 {
      font-weight: bold;
      font-size: 26px;
      color: #333333;
    }
    p {
      font-size: 26px;
      color: #333333;
      line-height: 39px;
    }
  }
  .Sudoku-item.bt {
    margin-bottom: 120px;
  }
  .focus-on {
    text-align: left;
    h2 {
      font-size: 38px;
      color: #F57F17;
      margin-bottom: 30px;
    }
    p {
      font-size: 26px;
      color: #333333;
      margin-bottom: 50px;
      line-height: 39px;
    }
  }
  .focus-on-box {
    border-radius: 12px;
    border: 3px solid #6C6C6C;
    margin-bottom: 50px;
    box-sizing: border-box;
    // overflow: hidden;
    .header {
      display: flex;
      align-items: center;
      padding: 0 20px;
      background-color: #6C6C6C;
      line-height: 90px;
      text-align: left;
      color: #ffffff;
      border: none;
      h3 {
        font-size: 30px;
        margin-right: auto;
      }
      button {
        width: 92px;
        height: 42px;
        border: none;
        line-height: 42px;
        border-radius: 8px;
        font-size: 24px;
      }
    }
    .label-box {
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
      display: flex;
      padding: 30px 20px;
      background-color: #EEEEEE;
      font-size: 26px;
      color: #333333;
      .label-box-left {
        font-weight: bold;
      }
      .label-box-right {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        .label {
          text-align: left;
          width: 33.33%;
          line-height: 39px;
        }
      }
    }
    .focus-on-content {
      padding: 30px 20px 20px 44px;
      font-size: 26px;
      color: #333333;
      ul,
      ul li {
        list-style-type: disc;
        text-align: left;
        line-height: 39px;
      }
    }
  }
  .small {
    font-size: 26px;
    color: #333333;
    text-align: left;
    line-height: 39px;
  }
}

.meacut_tvc {
  margin-top: 50px;
  text-align: justify;
  h1 {
    font-size: 38px;
    color: #333333;
    font-weight: bold;
    img {
      width: 55px;
      margin: 0 10px;
    }
  }
  h2 {
    margin-top: changeRem(.35) + px;
    color: #333;
    font-size: 32px;
  }
}

.av {
  width: 220px;
  height: 60px;
  background: rgba(245, 127, 23, 1);
  border-radius: 8px;
  line-height: 60px;
  font-size: 26px;
  text-align: center;
  color: #fff;
  margin-top: 10px;
  margin-left: 120px;
}

.pb-public {
  width: 8rem;
  padding: 40px;
}

.mt34 {
  margin-top: 34px;
}

.text-yellow {
  color: #F57F17;
}

.text-bold {
  font-weight: bold;
}

.meacut_circle {
  width: 180px;
  float: left;
  margin-right: 40px;
  margin-top: 80px;
  h2 {
    margin-top: 20px;
    line-height: 20px;
    font-size: 26px;
    color: #333;
  }
}

.meacut_circle.last {
  margin-right: 0;
}

.circle_h3 {
  font-size: 26px;
  color: #50509C;
  line-height: 40px;
  margin-top: 50px;
  text-align: center;
}

.confirm_box {
  padding: 50px 40px;
  border-radius: 12px;
}

.confirm_box h3 {
  margin: 10px 0;
  color: #999;
  font-size: 26px;
  text-align: center;
}

.confirm_box a.cancel {
  color: #fff;
  background-color: #EB5032;
  line-height: 60px;
  text-align: center;
  font-size: 28px;
  display: block;
  margin: 0 auto;
  margin-top: 40px;
  border-radius: 8px
}

.grouping .van-cell .van-cell__value input {
  border: 2px solid #ccc;
  border-radius: 12px;
  font-size: 26px;
  color: #333;
}
// 关卡信息
.levelbtn-group{
  display: flex;
  line-height: 98px;
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 50%;
  max-width: 750px;
  transform: translateX(-50%);
  z-index: 998;
  background-color: #EB5032;
  a{
    flex: 1;
    display: block;
    text-align: center;
    font-size: 32px;
    color: #ffffff;
    &:nth-child(1){
      border-right: 1px solid #ffffff;
    }
    &:last-child{
      border-left: 1px solid #ffffff;
    }
  }
}
</style>
